// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"breadcrumbs_wrapper__cD6VV","list":"breadcrumbs_list__pEyRc","listItem":"breadcrumbs_listItem__BbKM8"};